<template>
  <div class="main-sub-header">
    <app-button-back v-if="showBack" @click="onBack" />
    <img
      v-if="!hideLogo"
      class="main-sub-header__logo-word-first-club"
      src="@/assets/svg/logo-word-first-club.svg"
      alt="FIRST CLUB"
      @click="onLogoClick"
    />
    <app-authenticated v-if="$breakpoint.xlAndDown">
      <app-button-chat
        class="main-sub-header__chat"
        v-tour-step="'chat'"
        @click="toggleChat"
      />
    </app-authenticated>
  </div>
</template>

<script>
import AppAuthenticated from "@/components/security/Authenticated";
import { mapGetters, mapActions } from "vuex";
import AppButtonBack from "@/components/ui/ButtonBack";
import AppButtonChat from "@/components/ui/ButtonChat";

export default {
  name: "AppSubHeader",
  components: { AppButtonChat, AppButtonBack, AppAuthenticated },
  props: {
    hideLogo: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters("friendLists", ["myFriendList", "invitedFriendList"]),
    showBack() {
      return this.$route.meta.back;
    },
    isCaptain() {
      return !!this.myFriendList;
    },
    isPassenger() {
      return !!this.invitedFriendList;
    },
    chatRoom() {
      if (this.isCaptain) {
        return String(this.myFriendList.id);
      }

      if (this.isPassenger) {
        return String(this.invitedFriendList.id);
      }

      return null;
    },
  },
  methods: {
    ...mapActions(["togglePrimaryChat"]),
    onLogoClick() {
      if (this.$auth.isAuthenticated()) {
        this.$router.push({ name: "my-plane" });
        return;
      }
      this.$router.push({ name: "home", params: { slide: 0 } });
    },
    onBack() {
      this.$emit("back", this.$route.meta.back);
    },
    toggleChat() {
      this.togglePrimaryChat();
    },
  },
};
</script>
